
import { Vue, Component, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import { getNewsListAsync } from '../api';
import { wxShareInfo } from '@/common/ts/common';
import newsItem from '../components/NewsItem.vue';

Vue.use(List);

@Component({components: { newsItem } })
export default class Home extends Vue {
  activeTabIndex = 0;
  navList = [
    { id: 1, text: '两会学习', classId: '9028' },
    { id: 2, text: '两会动态', classId: '9029' },
    { id: 3, text: '报告解读', classId: '9030' },
    { id: 4, text: '重庆声音', classId: '9031' },
    { id: 5, text: '会场内外', classId: '9032' },
    { id: 6, text: '江山多娇', classId: '9033' },
    { id: 7, text: '“上星”联动', classId: '9034' },
    { id: 8, text: '北京来电', classId: '9035' },
  ];
  newsList: any[] = [];
  focusNews: any = {
    imageUrl: [],
  };
  loading = false;
  finished = false;
  page = 1;
  error = false;

  @Watch('activeTabIndex')
  onActiveTabIndexChange(newval: number) {
    this.resetNewsList();
    this.getNewsList();
  }

  created() {
    this.getNewsList();
    // 处理分享
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    wxShareInfo({
      title: '中国，行稳致远',
      subtitle: '2022全国两会',
      image: cover,
    });
    this.$appShareInfo({
      title: '中国，行稳致远',
      url: location.href,
      subtitle: '2022全国两会',
      image: cover,
      classId: -1,
      id: -1,
      type: 3,
    });
  }
  async getNewsList() {
    if (this.finished) {
      return console.log('没有更多了');
    }
    this.loading = true;
    try {
      const ret: any = await getNewsListAsync({
        page: this.page,
        classId: this.navList[this.activeTabIndex].classId,
      });
      this.loading = false;
      console.log(ret);
      if (!ret.data || !ret.data.length) {
        this.finished = true;
      } else {
        this.newsList = [
          ...this.newsList,
          ...ret.data.filter(
            (item: any) => item.dataType !== 5 && item.dataType !== 0,
          ),
        ];
        this.page++;
      }
    } catch (err) {
      console.log('异常报告', err);
      this.error = true;
    }
  }

  resetNewsList() {
    this.finished = false;
    this.newsList = [];
    this.page = 1;
  }
  onNavChange(tabIndex: number) {
    this.activeTabIndex = tabIndex;
  }
  onJumpToDetail(newsItem: any) {
    console.log(newsItem);
    if (window.udid && newsItem.dataType !== 7 && newsItem.dataType !== 5) {
      const { id, classId, dataType } = newsItem;
      const option = {
        dt: dataType,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = newsItem.targetUrl;
    }
  }
  onJumpToOutside() {
    location.href = 'https://activity.cqcb.com/shangyou_activity/2022h1/2022LHYWD';
  }
}
